import { useState } from "react";

import Popover from "@vapor/react-material/Popover";
import CircularProgress from "@vapor/react-material/CircularProgress";
import Box from "@vapor/react-material/Box";

import { EMBED_CLOSE_MSG, EMBED_READY_MSG } from "./use-embed-page";
import { EmbedIFrame } from "../components/EmbedIFrame";

export const useEmbedPopover = (targetUrn, config = {}) => {
  // Controls the open/close state:
  const [anchorEl, setAnchorEl] = useState(null);
  const [wasOpen, setWasOpen] = useState(config.preload);
  const [isReady, setIsReady] = useState(false);

  const open = (event) => {
    setAnchorEl(event.currentTarget);
    setWasOpen(true);
  };

  const close = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const api = { isOpen, open, close };

  const {
    scope = "popup",
    params = {},
    events = {},
    width = "20vw",
    height = "30vw",
    anchorOrigin = {
      vertical: "bottom",
      horizontal: "left"
    },
    LoadingComponent = CircularProgress,
    loadingComponentProps = {},
    popoverProps = {},
    iframeProps = {}
  } = config;

  // Wrap all the events with auto-close behavior:
  Object.keys(events).forEach((evt) => {
    const fn = events[evt];
    events[evt] = (data) => {
      if (fn(data, api) !== false) {
        close();
      }
    };
  });

  // Add Popover API events:
  events[EMBED_READY_MSG] = () => setIsReady(true);
  events[EMBED_CLOSE_MSG] = close;

  return {
    ...api,
    el: (
      <Popover
        {...popoverProps}
        id={id}
        onClose={close}
        open={isOpen}
        keepMounted={wasOpen}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
      >
        {isReady ? null : (
          <Box
            sx={{
              width,
              flex: 1,
              height,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <LoadingComponent {...loadingComponentProps} />
          </Box>
        )}
        <EmbedIFrame
          {...iframeProps}
          src={targetUrn}
          scope={scope}
          params={params}
          events={events}
          style={{
            ...(iframeProps.style || {}),
            width,
            height,
            flex: 1,
            display: isReady ? "block" : "none"
          }}
        />
      </Popover>
    )
  };
};
